module.exports = __webpack_public_path__ + "img/6.c6e1facd.jpg";